var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 8.10001L8.8 22.5C8 23.1 7.5 24 7.5 25V50.4C7.5 51.3 8.2 52 9.1 52H50.9C51.8 52 52.5 51.3 52.5 50.4V24.9C52.5 23.9 52 23 51.2 22.4L30 8.10001Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4 14.1V27.3L30 38.4L11.8 26.8V14.1H47.4Z",
    fill: "#FFF4DE",
    stroke: "#FFF4DE",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 33.4C26.4 33.4 23.6 30.3 24 26.7C24.3 23.9 26.5 21.7 29.3 21.4C32.1 21.1 36 23.8 36 27.4C36 27.4 36 29.9 34.6 29.9C32 29.9 32.3 26.3 32.3 26.9C32.3 28.3 31.7 30 30.1 30C28.5 30 28 28.9 28 27.5C28 26.1 28.9 24.7 30.4 24.7C31.9 24.7 32.4 26.2 32.4 26.7",
    stroke: "#FF931E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.c8fabedaaeca3f30ecf913fb17eddad7.svg";
export { ForwardRef as ReactComponent };